// src/screens/ProveedorDetalleServicioScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db, storage } from '../firebaseConfig'; // Importamos storage
import { doc, getDoc, updateDoc } from 'firebase/firestore'; // Importamos updateDoc
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'; // Imports de Storage
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoMapOutline, IoCallOutline, IoCloudUploadOutline } from 'react-icons/io5'; // Imports de iconos
import moment from 'moment';

function ProveedorDetalleServicioScreen() {
  const navigate = useNavigate();
  const { servicioId } = useParams();
  const { userData } = useAuth();
  
  const [servicio, setServicio] = useState(null);
  const [condominio, setCondominio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [enviando, setEnviando] = useState(false);
  const [archivosAntes, setArchivosAntes] = useState([]);
  const [previewsAntes, setPreviewsAntes] = useState([]);
  const [costoFinal, setCostoFinal] = useState('');
  const [formError, setFormError] = useState('');

  // useEffect de Carga
  useEffect(() => {
    if (!servicioId || !userData?.proveedorId) return;

    const fetchDatos = async () => {
      setLoading(true);
      try {
        const servicioRef = doc(db, "cotizaciones", servicioId);
        const servicioSnap = await getDoc(servicioRef);

        if (servicioSnap.exists()) {
          const data = servicioSnap.data();
          if (data.proveedorId !== userData.proveedorId || (data.estatus !== 'aceptada' && data.estatus !== 'pendiente_pago')) {
        	   setError("Servicio no encontrado o no autorizado.");
    	       setLoading(false);
    	     	 return;
    	     }
    	   	 setServicio(data);
    	   	 if (data.costoFinal) {
    	 	     setCostoFinal(data.costoFinal);
    	 	   }

    	 	   const condoRef = doc(db, "condominios", data.condominioId);
          // --- ¡AQUÍ ESTÁ LA CORRECCIÓN! ---
          // La variable se llama 'condoSnap', no 'docSnap'
    	 	   const condoSnap = await getDoc(condoRef);
    	 	   if (condoSnap.exists()) { 
    	 	 	   setCondominio(condoSnap.data());
    	 	 	 }
    	     
    	 	 } else {
    	 	   setError("No se encontró el servicio.");
    	 	 }
    	 } catch (e) {
    	   setError("Error al cargar los datos.");
    	   console.error(e);
    	 }
    	 setLoading(false);
    };

    fetchDatos();
  }, [servicioId, userData]);

  // (handleFileChange sin cambios)
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setArchivosAntes(files);
    
    const newPreviews = files
      .filter(file => file.type.startsWith('image/'))
      .map(file => URL.createObjectURL(file));
    setPreviewsAntes(newPreviews);
  };

  // (handleSubmitPresupuestoFinal sin cambios)
  const handleSubmitPresupuestoFinal = async (e) => {
    e.preventDefault();
    setFormError('');
    
    if (costoFinal <= 0) {
      setFormError("El costo final debe ser mayor a $0.");
      return;
    }
    if (archivosAntes.length === 0) {
      setFormError("Debes subir al menos una foto de evidencia (Antes).");
      return;
    }

    setEnviando(true);
    
    try {
      const urlsEvidenciaAntes = [];
      for (const file of archivosAntes) {
        const storageRef = ref(storage, `cotizaciones/${servicioId}/antes/${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        urlsEvidenciaAntes.push(url);
      }
      
      const docRef = doc(db, "cotizaciones", servicioId);
      await updateDoc(docRef, {
        costoFinal: Number(costoFinal),
        evidenciaAntesUrls: urlsEvidenciaAntes,
        estatus: "pendiente_pago"
      });
      
      alert("Presupuesto final enviado al residente. Esperando aprobación de pago.");
      navigate('/proveedor/servicios');

    } catch (e) {
      console.error("Error al enviar presupuesto final: ", e);
      setFormError("Error al guardar y subir la evidencia.");
    }
    setEnviando(false);
  };

  // (Guardias de renderizado sin cambios)
  if (loading) { return <div className="form-container"><p>Cargando servicio...</p></div>; }
  if (error) { return <div className="form-container"><p className="form-mensaje error">{error}</p></div>; }
  if (!servicio) { return null; }

  const direccion = condominio?.direccion || 'Dirección no disponible';
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(direccion)}`;

  return (
    <div className="form-container" style={{maxWidth: '700px'}}>
      <div className="form-header-container">
        <button onClick={() => navigate('/proveedor/servicios')} className="form-back-button">
          <IoArrowBack />
      	 </button>
    	 <h1 className="form-header">Detalle del Servicio</h1>
    </div>

    <div className="form-group-section">
      <h3>Cliente y Ubicación</h3>
    	 <div className="modal-info-grid">
        <span>Residente:</span>
        <span>{servicio.nombreResidente}</span>
        <span>Unidad:</span>
  	     <span>{servicio.unidadResidente}</span>
    	   <span>Condominio:</span>
        <span>{servicio.nombreCondominio}</span>
        <span>Dirección:</span>
        <a href={googleMapsLink} target="_blank" rel="noopener noreferrer" className="form-link-button">
          <IoMapOutline /> Ver en Google Maps
    	   </a>
    	 </div>
    </div>

    <div className="form-group-section" style={{marginTop: '20px'}}>
      <h3>Servicio Aceptado</h3>
  	   <div className="modal-info-grid">
  	 	 <span>Fecha Sugerida:</span>
  	 	 <span style={{fontWeight: 'bold'}}>
  	 	   {servicio.fechaHoraServicioSugerido
  	 	     ? moment(servicio.fechaHoraServicioSugerido.toDate()).format('dddd D [de] MMMM, h:mm a')
    	 	   : 'No especificada'}
    	 	 </span>
    	 	 <span>Estimado Aceptado:</span>
    	 	 <span style={{fontWeight: 'bold', color: '#007bff'}}>
    	 	   ${servicio.costoMin} - ${servicio.costoMax} MXN
    	 	 </span>
    	 	 <span>Descripción:</span>
    	 	 <span>{servicio.descripcion}</span>
    	 </div>
    </div>
      
    <div className="form-group" style={{marginTop: '20px', display: 'flex', gap: '15px'}}>
      <button className="form-button secondary" onClick={() => alert('Función de contacto (chat) no implementada.')}>
    	   <IoCallOutline /> Contactar Cliente
    	 </button>
    	 <button className="form-button" onClick={() => window.open(googleMapsLink, '_blank')}>
        <IoMapOutline /> Dirigirse al Servicio
    	 </button>
    </div>

    {/* --- (Formulario de Evidencia y Costo Final sin cambios) --- */}
    {servicio.estatus === 'aceptada' && (
      <form onSubmit={handleSubmitPresupuestoFinal} className="form-group-section" style={{marginTop: '20px'}}>
        <h3>Evidencia y Costo Final</h3>
        <p>Toma fotos del problema ANTES de empezar y define el costo final.</p>
        
        {formError && <p className="form-mensaje error">{formError}</p>}
        
        <div className="form-group">
          <label className="form-label">Costo Final (MXN)</label>
          <input 
            type="number" 
            value={costoFinal}
            onChange={(e) => setCostoFinal(e.target.value)}
            className="form-input" 
            placeholder="Costo total del servicio"
            min="0.01"
            step="0.01"
            required 
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Evidencia (Antes)</label>
          <input
            type="file"
            className="form-input"
            multiple
            onChange={handleFileChange}
            accept="image/*,video/*"
            required
          />
        </div>

        {previewsAntes.length > 0 && (
          <div className="gallery-container" style={{gridTemplateColumns: 'repeat(4, 1fr)'}}>
            {previewsAntes.map((previewUrl, index) => (
              <img key={index} src={previewUrl} alt="Evidencia antes" />
            ))}
          </div>
        )}
        
        <button type="submit" className="form-button" disabled={enviando} style={{marginTop: '20px', backgroundColor: '#28a745'}}>
          {enviando ? 'Enviando...' : 'Enviar Presupuesto Final'}
        </button>
      </form>
    )}

    {servicio.estatus === 'pendiente_pago' && (
      <div className="form-group-section" style={{marginTop: '20px'}}>
        <h3>Presupuesto Final Enviado</h3>
        <div className="modal-info-grid">
          <span>Costo Final:</span>
          <span style={{fontWeight: 'bold', color: '#dc3545'}}>
            ${servicio.costoFinal} MXN
          </span>
        </div>
        <p className="form-mensaje" style={{backgroundColor: '#fff3cd', color: '#856404'}}>
          Esperando aprobación de pago del residente...
        </p>
      </div>
    )}

    </div>
  );
}

export default ProveedorDetalleServicioScreen;